import { render, staticRenderFns } from "./ThemeTemplate.vue?vue&type=template&id=09f960aa&scoped=true&"
import script from "./ThemeTemplate.vue?vue&type=script&lang=js&"
export * from "./ThemeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ThemeTemplate.vue?vue&type=style&index=0&id=09f960aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f960aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
